import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { BylineConnectionsPlaceholder } from '../src/BylineConnectionsPlaceholder.tsx';

export type { DevDocsBylineConnectionAncestor } from '../src/BylineConnections.tsx';

export const BylineConnections: LoadableType<any> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BylineConnections" */ '../src/BylineConnections.tsx'
			)
		).BylineConnections,
	loading: BylineConnectionsPlaceholder,
});
